<template lang="pug">
  v-form(
    class="form-new-email"
    @submit.prevent.stop="submit"
  )
    ValidationObserver(ref="emailForm")
      ValidationProvider(
        :name="wrapQuotesProviderName($t('New email address'))"
        vid="code"
        rules="required|email"
        mode="lazy"
        v-slot="{ errors }"
      )
        v-text-field(
          v-model="email"
          filled
          :label="$t('Enter new email address')"
          :error-messages="errors"
        )
    div(:class="{ 'two-buttons-wrapper pt-8': !xsDevice }")
      v-btn(
        v-if="!xsDevice"
        height="48"
        @click="closeModal(false)"
      ) {{ $t('Cancel') }}
      v-btn(
        type="submit"
        class="main-button"
        :class="{ 'w-100': xsDevice }"
        :loading="loading"
      ) {{ $t('Continue') }}
</template>

<script>
import MOtpInput from '~/modules/auth/components/modules/m-otp-input'
import validate from '~/mixins/validation/validate'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'FormNewEmail',
  components: { MOtpInput },
  mixins: [validate, responsive],
  props: {
    closeModal: {
      type: Function,
      default: null
    },
    taskId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      email: null
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.emailForm.validate()
      if (!valid) {
        return
      }
      try {
        this.loading = true
        await this.$store.dispatch('users/setNewEmail', { id: this.taskId, email: this.email })
        this.$emit('getNewEmail', this.email)
        this.$emit('nextStep')
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@supports (-webkit-touch-callout: none) {
  .form-new-email {
    input,
    textarea,
    select,
    .v-input input,
    .v-text-field input,
    .v-select input,
    .v-textarea textarea {
      font-size: 16px !important;
    }
  }
}
.form-new-email {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: map-get($breakpoints, 'sm')) {
    height: auto;
    display: inline-block;
  }
}
</style>
